// deps
import React from "react";

// interfaces
import { AddMoneyAggregateResponse } from "@payment-client/interfaces/SwiggyMoney";

export interface AddMoneyDetailsState {
    fetchDataInProgress: boolean;
    addMoneyData?: AddMoneyAggregateResponse;
    criticalError?: {
        error: boolean;
        message: string;
    };
}

export interface AddMoneyContextValue {
    data: AddMoneyDetailsState;
    originalBillAmount?: number;
    getAddMoneyRequestData: (originalBillAmount?: number) => void;
    updateSelectedAmount: (amount: number) => void;
    selectedAmount: number;
}

export const AddSwiggyMoneyContext = React.createContext<AddMoneyContextValue>({
    data: {
        fetchDataInProgress: false,
        criticalError: {
            error: false,
            message: "",
        },
    },
    selectedAmount: 0,
    getAddMoneyRequestData: () => void 0,
    updateSelectedAmount: () => void 0,
});

if (__DEV__) {
    AddSwiggyMoneyContext.displayName = "AddSwiggyMoneyContext";
}
